import { Injectable } from '@angular/core';
import { MobileBreakPointsService } from './mobileBreakPoints.service';
import { Observable } from 'rxjs';
import { Store } from '@ngrx/store';
// import { MatDialog } from '@angular/material/dialog'; // Todo: Tim: need to update to non-legacy MUI component
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { defaultCountry } from '../store/service-options';
import { isLocationSelected } from '../store/transaction';
import { DialogLocationMapComponent } from '../shared/dialog-location-map/dialog-location-map.component';
import { StringUtils } from '../shared/utils/string-utils';
import { Labels } from '../app.models';

@Injectable({
  providedIn: 'root'
})
export class LocationSelectService {
  private isMobile$: Observable<boolean>;
  public isLocationSelected$: Observable<boolean>;
  private isMobileSize: boolean;
  private openDialogMobile: boolean = false;
  public country: string = '';

  constructor(
      private store: Store,
      public dialogLocationMap: MatDialog,
      private _mobileBreakPoinntService: MobileBreakPointsService
    ) {
      this.isMobile$ = this._mobileBreakPoinntService.mobileBreakPoints$;
    }

  ngOnInit(): void {
    this.isMobile$.subscribe((isMobile) => {
      this.isMobileSize = isMobile;
    });
    this.store.select(defaultCountry).subscribe((country) => {
      this.country = country;
    });
    this.isLocationSelected$ = this.store.select(isLocationSelected);
  }

  openDialog(labels: Labels, google: any, flow: string): void {
    const dialogbRef = this.dialogLocationMap.open(DialogLocationMapComponent, {
      data: {
        labels: labels,
        google: google,
        flow: flow,
        isSupportPanelOpen: !this.openDialogMobile,
        toogleSupportPanel: (payload: boolean) => {
          this.toggleDialogMobile(payload);
        },
      },
      backdropClass: 'back-transparent',
      panelClass: 'dialog-no-animations',
    });
    dialogbRef.afterOpened().subscribe(() => {
      this.toggleDialogMobile(!this.openDialogMobile);
    });
  }

  public toggleDialogMobile(openDialogMob: boolean) {
    this.openDialogMobile = openDialogMob;
  }

  public capSentence1Letter(value: string | undefined) {
    return StringUtils.capitalizeWord(value);
  }
}
